import { ReportProblem } from '@/shared-ui';

import RatingScaleSelect from './project-response-rating-scale-select';
import { ProjectResponseComponentProps } from './project-response-renderer.type';

const EMPTY_OPTIONS: NonNullable<ProjectResponseComponentProps['options']> = [];

export function ProjectResponseRatingScaleRendererComponent({
  id,
  app,
  options = EMPTY_OPTIONS,
  text,
  value,
  tentativeValue,
  onChange,
  readonly,
  optionRenderType,
  assets,
  audio,
  isAiVoiceEnabled,
  isFollowUp = false,
  onSubmit,
  questionId,
  numeralLocale,
}: ProjectResponseComponentProps) {
  return (
    <div
      data-test='rating-scale-renderer'
      className='isolate flex w-full flex-col gap-1'
    >
      <RatingScaleSelect
        app={app}
        numeralLocale={numeralLocale}
        onClick={(value) => onChange?.(value)}
        options={options}
        value={value ?? ''}
        tentativeValue={tentativeValue}
        readonly={readonly}
        optionRenderType={optionRenderType}
        assets={assets}
        text={text}
        className='flex gap-4 rounded-2xl px-6 py-8'
        contentClassName='gap-2'
        audio={audio}
        isAiVoiceEnabled={isAiVoiceEnabled}
      />
      {onSubmit && id && (
        <ReportProblem
          context={{ messageId: id, questionId: questionId ?? undefined }}
          onSubmit={onSubmit}
          variant={isFollowUp ? 'follow-up' : 'main'}
          className='self-start'
        />
      )}
    </div>
  );
}
